import { render } from "./MandateContractWrapper.vue?vue&type=template&id=72a1c8ec"
import script from "./MandateContractWrapper.vue?vue&type=script&lang=js"
export * from "./MandateContractWrapper.vue?vue&type=script&lang=js"

import exportComponent from "../../../../node_modules/@vue/cli-service/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__